import { Dialog } from "primereact/dialog";
import "./styles/DialogZegel.scss";
const DialogImage = (props) => {
  return (
    <Dialog
      {...props}
      className="dialog-image"
    >
      {props.contenido}
    </Dialog>
  );
};

export default DialogImage;
